import _ from 'lodash';
import { Container } from 'unstated';
import papa from 'papaparse';


// division layout for 2019
// clockwise
var divisions = {
    mens: [
        'South',
        'Midwest',
        'West',
        'East'
    ], womens:[
        'Chicago',
        'Albany',
        'Portland',
        'Greensboro'
    ]};

const csvUrl = "https://projects.fivethirtyeight.com/march-madness-api/2019/fivethirtyeight_ncaa_forecasts.csv";

// load the data from the 538 dataset
function setupData(dataset, gender) {
    var teamData = {};
    teamData.rounds = [];

    gender = gender || 'mens' || 'womens';
    var divs = divisions[gender];
    const date = _(dataset).find({'gender': gender}).forecast_date;

    // prediction data from 538
    let predictionChain = _(dataset)
        .filter({gender: gender})
        .filter({forecast_date:date});

    teamData.rounds.push(_.concat(
        predictionChain.filter({team_region:divs[0]}).sortBy('rd1_win').reverse().slice(0,16).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[1]}).sortBy('rd1_win').reverse().slice(0,16).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[2]}).sortBy('rd1_win').reverse().slice(0,16).sortBy('team_slot').reverse().value(),
        predictionChain.filter({team_region:divs[3]}).sortBy('rd1_win').reverse().slice(0,16).sortBy('team_slot').reverse().value()));

    teamData.rounds.push(_.concat(
        predictionChain.filter({team_region:divs[0]}).sortBy('rd2_win').reverse().slice(0,8).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[1]}).sortBy('rd2_win').reverse().slice(0,8).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[2]}).sortBy('rd2_win').reverse().slice(0,8).sortBy('team_slot').reverse().value(),
        predictionChain.filter({team_region:divs[3]}).sortBy('rd2_win').reverse().slice(0,8).sortBy('team_slot').reverse().value()));

    teamData.rounds.push(_.concat(
        predictionChain.filter({team_region:divs[0]}).sortBy('rd3_win').reverse().slice(0,4).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[1]}).sortBy('rd3_win').reverse().slice(0,4).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[2]}).sortBy('rd3_win').reverse().slice(0,4).sortBy('team_slot').reverse().value(),
        predictionChain.filter({team_region:divs[3]}).sortBy('rd3_win').reverse().slice(0,4).sortBy('team_slot').reverse().value()));

    teamData.rounds.push(_.concat(
        predictionChain.filter({team_region:divs[0]}).sortBy('rd4_win').reverse().slice(0,2).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[1]}).sortBy('rd4_win').reverse().slice(0,2).sortBy('team_slot').value(),
        predictionChain.filter({team_region:divs[2]}).sortBy('rd4_win').reverse().slice(0,2).sortBy('team_slot').reverse().value(),
        predictionChain.filter({team_region:divs[3]}).sortBy('rd4_win').reverse().slice(0,2).sortBy('team_slot').reverse().value()));

    // round 5
    // regional champ - get highest for each section
    teamData.rounds.push([
        predictionChain.filter({team_region:divs[0]}).sortBy('rd5_win').last(),
        predictionChain.filter({team_region:divs[1]}).sortBy('rd5_win').last(),
        predictionChain.filter({team_region:divs[2]}).sortBy('rd5_win').last(),
        predictionChain.filter({team_region:divs[3]}).sortBy('rd5_win').last()
    ]);

    // round 6
    // finals - grab highest prediction in each region
    var leftFinals = predictionChain.filter((team) => {
        return team.team_region === divs[3] || team.team_region === divs[2];
    }).sortBy('rd6_win').last();
    var rightFinals = predictionChain.filter((team) => {
        return team.team_region === divs[0] || team.team_region === divs[1];
    }).sortBy('rd6_win').last();
    teamData.rounds.push([rightFinals, leftFinals]);


    // round 7
    // champion, so just grab the highest rd7_win data
    teamData.rounds.push([predictionChain
        .filter((val) => val.rd7_win)
        .sortBy('rd7_win')
        .last()]);

    teamData.topTeam = teamData.rounds[6][0];
    return teamData;
}

class TeamContainer extends Container {
    constructor(props = {}) {
        super();
        this.state = {
            gender: 'mens'
        };

        this.fetchData().then((result) => {
            var teamData = setupData(result.data, 'mens');
            this.setState({
                data: result.data,
                rounds: teamData.rounds,
                currentTeam: teamData.topTeam,
                gender: 'mens'
            });
        });
    }

    fetchData = async () => {
        return new Promise((resolve, reject) => {
            papa.parse(csvUrl, {
                download: true, 
                dynamicTyping: true,
                header: true,
                complete: resolve, 
                error: reject});
        });
    }

    getGender = () => {
        return this.state.gender;
    }
    
    changeGender = () => {
        return this.setState((oldState) => {
            var gender = oldState.gender;
            if (gender === 'mens') {
               gender = "womens";
            } else {
                gender = "mens";
            } 
            let teamData = setupData(this.state.data, gender);
            return {
                rounds: teamData.rounds,
                currentTeam: teamData.topTeam,
                gender: gender
            }
        });
    }

    // return divisions in clockwise order
    getDivisions = () => {
        return divisions[this.state.gender];
    }

    reset = () => {
        let teamData = setupData(this.state.data);
        return this.setState({rounds: teamData.rounds});
    }

    setCurrentTeam = (team) => {
        return this.setState({currentTeam : team});
    }

    setCurrentRound = (round) => {
        return this.setState({currentRound: round});
    }

    getCurrentTeam = () => {
        return this.state.currentTeam;
    }

    getCurrentRound = () => {
        return this.state.currentRound;
    }

    getRound = (roundNum) => {
        return this.state.rounds[roundNum];
    }

    onHover = (team, round) => {
        return this.setCurrentTeam(team).then(() => {
            this.setCurrentRound(round);
        });
    }
    onClick = (team, round) => {
        round = round - 1;
        if (round > 6) {
            return;
        }

        let newRound = round + 1;

        // find old index
        const oldIndex = _.findIndex(this.state.rounds[round],{team_id:team.team_id});
        let newIndex = oldIndex>>1;
        // find idx for next one

        var losingTeamId;
        if (oldIndex % 2) {
            losingTeamId = this.state.rounds[round][oldIndex - 1].team_id;
        } else {
            losingTeamId = this.state.rounds[round][oldIndex + 1].team_id;
        }
        return this.setState((oldState) => {
            oldState.rounds[newRound][newIndex] = team;
            while(newRound < 6) {
                newRound = newRound + 1;
                newIndex = newIndex >> 1;
                if (oldState.rounds[newRound][newIndex].team_id === losingTeamId) {
                    oldState.rounds[newRound][newIndex] = {};
                }
            }
            return {rounds: oldState.rounds, currentTeam: oldState.currentTeam};
        });
    }

    getDate = () =>{
        return _.get(this.state,'rounds[0][0].forecast_date');
    }
}
export default TeamContainer;